<template>
  <div>
    <section class="grid-flex">
      <div id="howto" class="box">
        <div class="box-title flex between middle scroll-side">
          <h2>{{ selectedVideo.title }}</h2>
          <div><b>Última atualização</b>: {{ lastUpdate }}</div>
        </div>
        <div class="grid-flex stretch">
          <div class="box-content grid-flex row" style="width: 100%">
            <div class="w60">
              <iframe
                width="100%"
                height="540"
                :src="'https://www.youtube.com/embed/' + selectedVideo.youtube"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="flex-1 w40 list-videos">
              <ul>
                <li
                  v-for="(video, index) in renderVideos"
                  :key="index"
                  @click="selectVideo(video)"
                >
                  <div
                    class="box video"
                    style="margin-bottom: 10px"
                    :class="{ active: video.youtube === selectedVideo.youtube }"
                  >
                    <div class="box-content flex" style="padding: 10px 20px">
                      <div class="image">
                        <img
                          width="130"
                          :src="
                            `https://img.youtube.com/vi/${video.youtube}/0.jpg`
                          "
                        />
                      </div>
                      <div class="video-info">
                        <div class="title">{{ video.title }}</div>
                        <div class="description">{{ video.description }}</div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "how-to",
  data() {
    return {
      selectedVideo: {},
      lastUpdate: "31/08/2024",
      videos: [
        {
          title: "Configuração FACEBOOK ADS",
          youtube: "JIgx4Srpvyg",
          description: "Configurando integração com facebook ads",
        },
        {
          title: "Configuração GOOGLE ADS",
          youtube: "w3e15Q5WzeQ",
          description: "Configurando integração com google ads",
        },
        {
          title: "Configuração HOTMART",
          youtube: "8L-SByjzqCI",
          description: "Configurando integração na hotmart",
        },
        {
          title: "Configuração KIWIFY",
          youtube: "JA14TmKJxbo",
          description: "Configurando integração na kiwify",
        },
        {
          title: "Configuração SHOPIFY",
          youtube: "tJipAy8bpzg",
          description: "Configurando integração na shopify",
        },
        {
          title: "Configuração CARTPANDA",
          youtube: "xkA8ryOHmho",
          description: "Configurando integração na cartpanda",
        },
        {
          title: "Configuração LPQV",
          youtube: "lp3iYHBVgFU",
          description: "Configurando integração na LPQV + webhook + pixel",
        },
      ],
      renderVideos: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isFreemium() {
      return this.account && this.account.plan === "Freemium";
    },
  },
  created() {
    if (this.isFreemium) {
      this.renderVideos = [
        this.videos.find((v) => {
          return v.title === "L-Zap";
        }),
      ];
    } else {
      this.renderVideos = this.videos;
    }

    // set first video
    this.selectVideo(this.renderVideos[0]);
  },
  methods: {
    selectVideo(video) {
      this.selectedVideo = video;
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  border-radius: 3px;
}
.list-videos {
  max-height: 550px;
  overflow: hidden;
  overflow-y: inherit;
  padding-left: 10px;
  padding-right: 10px;
  > ul {
    list-style-type: none;
    li {
      cursor: pointer;
      .active {
        background: #3e036d1a;
        .title {
          border-bottom: 1px solid #999;
        }
      }
    }
  }

  .video-info {
    padding-left: 10px;
    width: 100%;

    .title {
      font-weight: 700;
      padding-bottom: 5px;
      border-bottom: 1px solid var(--border0);
    }

    .description {
      margin-top: 10px;
    }
  }
}

.w60 {
  width: 70%;
}

@media screen and (max-width: 1024px) {
  .row {
    flex-direction: column !important;
  }
  .w60 {
    width: 100%;
  }
  .w40 {
    width: 100%;
  }
  .list-videos {
    margin-top: 30px;
  }
}
</style>
